import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { SetupPhase, SetupStep } from '@core/models';

/**
 * Get Started actions. The steps are authored data: the page loads them, and an
 * admin's edits replace the whole list — the order is part of what's authored, so
 * there is nothing to patch row-by-row.
 */
export const SetupPageActions = createActionGroup({
  source: 'Get Started Page',
  events: {
    Entered: emptyProps(),
    /** An admin added, edited, removed or reordered a step (session-only). */
    'Steps Changed': props<{ steps: SetupStep[] }>(),
    /** An admin added, renamed, removed or reordered a group (session-only). */
    'Phases Changed': props<{ phases: SetupPhase[] }>(),
  },
});

export const SetupApiActions = createActionGroup({
  source: 'Get Started API',
  events: {
    'Load Success': props<{ steps: SetupStep[]; phases: SetupPhase[] }>(),
    'Load Failure': props<{ error: string }>(),
  },
});
